import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';

import { TranslateModule } from '@ngx-translate/core';

import { ScheduledEventsCommonModule } from 'rev-portal/scheduledEvents/common/ScheduledEventsCommon.AngularModule';

import { ButtonsAngularModule } from 'rev-shared/ui/buttons/ButtonsAngular.Module';
import { VbUiTooltipModule } from 'rev-shared/ui/tooltip/VbUiTooltip.Module';

import { VbWebcastEmbeddedContentSidebarComponent } from './VbWebcastEmbeddedContentSidebar.Component';
import { VbWebcastEmbeddedContentComponent } from './VbWebcastEmbeddedContent.Component';

const components = [
	VbWebcastEmbeddedContentSidebarComponent,
	VbWebcastEmbeddedContentComponent
];

@NgModule({
	declarations: components,
	exports: components,
	imports: [
		ButtonsAngularModule,
		CommonModule,
		FormsModule,
		TranslateModule,
		VbUiTooltipModule,
		ScheduledEventsCommonModule
	]
})
export class VbWebcastEmbeddedContentModule {}
